//
// Module for the request edit view
//
rs.module("system_/configuration/portalrequestconfig/edit",

    [
    ],

    function () {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, gridVariable, columnIds) {
            var portalRequestConfigForm = $.js(jsSelectors.portalRequestConfigForm);
            var addStageLink = portalRequestConfigForm.js(jsSelectors.addStageLink);
            var alwaysStartWorkflowCheckBox = portalRequestConfigForm.js(jsSelectors.alwaysStartWorkflowCheckBox);
            var workflowSelect = portalRequestConfigForm.js(jsSelectors.workflowSelect);

            // On Start Workflow select change, toggle the Always Start checkbox
            workflowSelect.change(function () {
                var enable = this.value != "";

                if (!enable) {
                    alwaysStartWorkflowCheckBox.prop('checked', false);
                }

                alwaysStartWorkflowCheckBox.prop('disabled', !enable);
            });

            // Hook up a grid's Add link click
            addStageLink.click(function () {
                
                // get current grid and add row
                if (gridVariable) {
                    var defaultData = {
                        [columnIds.StageOrder]: portalRequestConfigForm.find(".ag-center-cols-container")[0].childElementCount + 1
                    };

                    gridVariable.addRow(defaultData);
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);